<template>
  <!--//@*/*
      //    *RPD  App v0.91
      //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
      //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
      //    */
      //-->
  <v-expansion-panel popout class="mt-4">
    <v-expansion-panel-header
      id="rec_traff_rpt_lib"
      @click="onExpansionPanelClick"
      class="accent white-text text-body2 text-md-h6"
      >TRAFFIC ACCIDENT REPORTS
      <!-- <div class="text-caption d-none d-sm-flex">
        &nbsp;&nbsp; (SEARCH FOR A TRAFFIC ACCIDENT REPORT WITHOUT SUBMITTING A
        NEW REQUEST)
      </div> -->
      <template v-slot:actions>
        <v-icon color="white" x-large> $expand </v-icon>
      </template></v-expansion-panel-header
    >
    <v-expansion-panel-content color="grey lighten-5">
      <div class="bcs-expansion-content mt-4">
        <div class="mt-6" style="color: black">
          <h4>To request a copy of your traffic accident report:</h4>
          <br />
          <h4>
            Visit
            <a
              href="https://secure.crashdocs.org/nv-cityofreno/"
              title="link to www.crashdocs.org/nv-cityofreno/"
              target="_blank"
              >CRASHDOCS.ORG RENO POLICE DEPT</a
            >
          </h4>
          <br />
          <!-- <h4>ON DESKTOP:</h4>
          <ul class="mt-1 desktop">
            <li>Click on Public Records Search (Highlighted in Yellow)</li>

            <li class="search-img" style="list-style: none">
              <img src="../assets/desktop_search.jpg" />
            </li>
            <li>Type in case number in the 'Keyword' box</li>
            <li>Click on 'Filter' to search for the case number</li>
            <li>
              Click on <v-icon color="black"> $search </v-icon> (Highlighted in
              Yellow) to see details
            </li>
            <li class="results-img" style="list-style: none">
              <img src="../assets/desktop_results.jpg" />
            </li>
            <li>Download to print document or view image</li>
          </ul>
          <br />

          <h4>ON MOBILE:</h4>
          <ul class="mt-1 mobile">
            <li class="menu-icon">
              Tap on the menu icon in the upper right
              <img src="../assets/mobile_menu_icon.jpg" />
            </li>
            <li>Tap on Public Records Search (Highlited in Yellow)</li>
            <li class="search-img" style="list-style: none">
              <img src="../assets/mobile_search.jpg" />
            </li>
            <li>Type in case number in the 'Keyword' box</li>
            <li>Tap on 'Filter' to search for the case number</li>
            <li>
              Scroll to the right and tap on
              <v-icon color="black"> $search </v-icon> (Highlighted in Yellow)
              to see details
            </li>
            <li class="results-img" style="list-style: none">
              <img src="../assets/mobile_results.jpg" />
            </li>
            <li>Download to print document or view image</li>
          </ul> -->
        </div>
      </div>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<style lang="scss" scoped>
@import "../scss/site.scss";
.bcs-expansion-content {
  color: black;
}

/* 0 media q */
@media (min-width: 0px) {
  .menu-icon img {
    width: 25px;
  }

  .desktop .search-img img,
  .desktop .results-img img {
    width: 100%;
  }

  .mobile .search-img img {
    width: 100%;
  }

  .mobile .results-img img {
    width: 100%;
  }
}

/* 961 media q */
/* tablet, landscape iPad, lo-res laptops ands desktops */
@media (min-width: 961px) {
  .desktop .search-img img,
  .desktop .results-img img {
    width: 40%;
  }

  .mobile .search-img img {
    width: 25%;
  }

  .mobile .results-img img {
    width: 25%;
  }
}
</style>
<script>
import { bus_common } from "../mixins/bus_common";
export default {
  name: "rec_traff_rpt_lib",
  mixins: [bus_common],
  data: function () {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    onExpansionPanelClick(event) {
      this.$emit("onExpansionPanelClick", event);
    },
    init: function () {
      this.show_loader(false);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
      // The whole view is rendered, so I can safely access or query
      // the DOM. ¯\_(ツ)_/¯
    });
  },
};
</script>
